import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { NoteSummary } from '~/models/modules/note';
import { NotesService } from '~/services/modules/stocks/notes';
import { ThemeManagerService } from '~/services/theme-manager';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'note',
    templateUrl: './note.html',
    styleUrls: ['./note.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoteComponent implements OnInit, OnChanges {
  @Input() _page: string;
  @Input() _pageState: PageState;
  @Input() _model: any;
  pageState = PageState;
  _theme: string;
  _note: string;
  _notes: NoteSummary[];
  _index: number;

  _editableNote: any;
  _isEditNote: boolean = false;

  constructor(private _themeManager: ThemeManagerService,
    private _notesService: NotesService) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._page && this._model) {

      this.getNotes(this._model.id, this._page);
    }
  }

  ngOnInit(): void { }

  editNote() {
    let model = {
      id: this._editableNote.id,
      description: this._editableNote.description,
    };
    this._notesService
      .editNote(model)
      
      .subscribe((x: any) => {
        this._isEditNote = false;
        this.getNotes(this._model.id, this._page);
      });
  }

  createNote(id: number = 0) {
    let modelId = id > 0 ? id : this._model.id;
    let model = {
      description: this._note,
      pageName: this._page,
      fileId: modelId,
    };
    if (this._note != null && modelId) {
      this._notesService
        .createNote(model)
        
        .subscribe((x: any) => {
          this._note = '';
          this.getNotes(modelId, this._page);
        });
    }
  }
  createNoteForUser(id: any = '') {
    let modelId = id ? id : this._model.id;
    let model = {
      description: this._note,
      pageName: this._page,
      fileId: modelId,
    };
    if (this._note != null && modelId) {
      this._notesService
        .createNote(model)
        
        .subscribe((x: any) => {
          this._note = '';
          this.getNotes(modelId, this._page);
        });
    }
  }

  getNotes(fileId: number, page: string) {
    if (fileId != undefined) {
      this._notesService
        .getNotesByPage(fileId, page)
        
        .subscribe((x: NoteSummary[]) => {
          this._notes = x;
        });
    }
  }

  editableNote(note: any) {
    this._editableNote = note;
  }

  processEditNote(i: number) {
    this._isEditNote = true;
    this._index = i;
  }
}
